import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import { parseUrl, parse, stringifyUrl } from 'query-string';
import _typeof from '@babel/runtime/helpers/typeof';
import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import forOwn from 'lodash/forOwn';
import indexOf from 'lodash/indexOf';
import isArray from 'lodash/isArray';
import ua from '@tencent/docs-user-agent';

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function cacheClientData(docIdOrCommon, obj) {
  var cacheName = 'ent-ssr-sandbox-data';
  if (typeof caches === 'undefined') return;
  return caches.open(cacheName).then(function (cache) {
    var url = "https://".concat(location.host, "/").concat(docIdOrCommon);
    return cache.match(url).then(function (res) {
      return res === null || res === void 0 ? void 0 : res.json();
    }).then(function (data) {
      if (!data) data = {};
      data = _objectSpread$2(_objectSpread$2({}, data), obj);
      return cache.put(url, new Response(JSON.stringify(data), {
        headers: {
          'Content-Type': 'application/json'
        }
      }));
    })["catch"](function (e) {
      if (typeof window !== 'undefined') {
        var _window, _window$log;

        (_window = window) === null || _window === void 0 ? void 0 : (_window$log = _window.log) === null || _window$log === void 0 ? void 0 : _window$log.error('sync to sandbox data failed', e);
      }
    });
  });
}

var LANG_MAPPER = {
  // 企微ua映射
  zh: 'zh-CN',
  // 简中
  zh_HK: 'zh-HK',
  // 繁中
  en: 'en-US',
  // 英语
  th: 'th',
  // 泰语
  vi: 'vi',
  // 菲律宾语
  ms: 'ms',
  //  马来语
  fil: 'tl-PH',
  // 菲律宾语
  id: 'id-ID',
  // 印尼语
  es: 'es-MX',
  // 西班牙语
  de: 'de',
  // 德语
  ja: 'ja',
  // 日语
  // 浏览器cookie
  'zh-CN': 'zh-CN',
  'zh-HK': 'zh-HK',
  'en-US': 'en-US',
  // 企微会议ua映射
  'zh-cn': 'zh-CN',
  'zh-tc': 'zh-HK',
  'en-us': 'en-US',
  // 下划线变中横线
  zh_CN: 'zh-CN',
  en_US: 'en-US',
  tl_PH: 'tl-PH',
  id_ID: 'id-ID',
  es_MX: 'es-MX'
};
function shareLanguage(instance, resources) {
  instance.on('languageChanged', function () {
    try {
      var _instance$languages$f;

      var locales = Object.keys(resources);
      var lng = (_instance$languages$f = instance.languages.find(function (l) {
        return locales.indexOf(l) !== -1;
      })) !== null && _instance$languages$f !== void 0 ? _instance$languages$f : ''; // 如果解析出来的 lng 是下划线式或是企微 UA 里的短名字，就转成中划线形式的标准写法。
      // 我们 localStorage 里存中划线的

      if (LANG_MAPPER[lng]) {
        lng = LANG_MAPPER[lng];
      } // 将最终的locale存入localStorage 让其他组件可以获取


      localStorage.setItem('shared-language', lng);
      cacheClientData('common', {
        lang: lng
      });
    } catch (e) {// do nothing
    }
  });
}

function getHostName() {
  if (typeof location !== 'undefined') {
    return location.hostname;
  }

  return '';
}
function getGlobal() {
  if (isMiniProgram()) {
    return getMiniProgramCtx();
  }

  if (typeof window !== 'undefined') {
    return window;
  }

  return {};
} // 是否小程序内打开

function isMiniProgram() {
  return typeof window === 'undefined' && typeof getMiniProgramCtx() !== 'undefined';
} // 小程序全局 API 对象

function getMiniProgramCtx() {
  // @ts-ignore
  return wx;
}

function log() {
  var _global$log, _console;

  var global = getGlobal();
  var prefix = '[wdocs-utils/xsrf]'; // weblog

  for (var _len = arguments.length, msg = new Array(_len), _key = 0; _key < _len; _key++) {
    msg[_key] = arguments[_key];
  }

  if (typeof ((_global$log = global.log) === null || _global$log === void 0 ? void 0 : _global$log.log) === 'function') {
    var _global$log2;

    (_global$log2 = global.log).log.apply(_global$log2, [prefix].concat(msg));
  }

  (_console = console).warn.apply(_console, [prefix].concat(msg));
}
function localLog() {
  var _window, _window$tdocs, _window2, _window2$WeixinJSBrid;

  for (var _len2 = arguments.length, msg = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    msg[_key2] = arguments[_key2];
  }

  if ((_window = window) !== null && _window !== void 0 && (_window$tdocs = _window.tdocs) !== null && _window$tdocs !== void 0 && _window$tdocs.log) {
    window.tdocs.log({
      message: msg.join()
    });
  } else if ((_window2 = window) !== null && _window2 !== void 0 && (_window2$WeixinJSBrid = _window2.WeixinJSBridge) !== null && _window2$WeixinJSBrid !== void 0 && _window2$WeixinJSBrid.invoke) {
    var _window$WeixinJSBridg, _window$WeixinJSBridg2;

    (_window$WeixinJSBridg = (_window$WeixinJSBridg2 = window.WeixinJSBridge).invoke) === null || _window$WeixinJSBridg === void 0 ? void 0 : _window$WeixinJSBridg.call(_window$WeixinJSBridg2, 'wwapp.wedoc.localLog', {
      level: 'info',
      msg: msg.join()
    }, function () {});
  } else {
    console.warn('该环境不支持localLog');
  }
}
var Logger = /*#__PURE__*/function () {
  function Logger() {
    _classCallCheck(this, Logger);
  }

  _createClass(Logger, null, [{
    key: "info",
    value: function info() {
      var _global$log3;

      var global = getGlobal();
      var prefix = '[info]'; // weblog

      for (var _len3 = arguments.length, msg = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        msg[_key3] = arguments[_key3];
      }

      if (typeof ((_global$log3 = global.log) === null || _global$log3 === void 0 ? void 0 : _global$log3.info) === 'function') {
        var _global$log4;

        (_global$log4 = global.log).info.apply(_global$log4, [prefix].concat(msg));
      } else {
        var _console2;

        (_console2 = console).info.apply(_console2, [prefix].concat(msg));
      }
    }
  }, {
    key: "warn",
    value: function warn() {
      var _global$log5;

      var global = getGlobal();
      var prefix = '[warn]'; // weblog

      for (var _len4 = arguments.length, msg = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        msg[_key4] = arguments[_key4];
      }

      if (typeof ((_global$log5 = global.log) === null || _global$log5 === void 0 ? void 0 : _global$log5.warn) === 'function') {
        var _global$log6;

        (_global$log6 = global.log).warn.apply(_global$log6, [prefix].concat(msg));
      } else {
        var _console3;

        (_console3 = console).warn.apply(_console3, [prefix].concat(msg));
      }
    }
  }, {
    key: "error",
    value: function error() {
      var _global$log7;

      var global = getGlobal();
      var prefix = '[error]'; // weblog

      for (var _len5 = arguments.length, msg = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        msg[_key5] = arguments[_key5];
      }

      if (typeof ((_global$log7 = global.log) === null || _global$log7 === void 0 ? void 0 : _global$log7.error) === 'function') {
        var _global$log8;

        (_global$log8 = global.log).error.apply(_global$log8, [prefix].concat(_toConsumableArray(msg.map(function (item) {
          if (item instanceof Error && item.toString) {
            return item.toString();
          }

          return item;
        }))));
      } else {
        var _console4;

        (_console4 = console).error.apply(_console4, [prefix].concat(msg));
      }
    }
  }]);

  return Logger;
}();

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/**
 * /doc/info?a=b
 * https://doc.weixin.qq.com/doc/info?c=d
 */

function getQuery(url, key) {
  var parsed = parseUrl(url);
  var val = parsed.query[key];
  return typeof val === 'string' ? val : null;
}
/**
 * /doc/info?a=b
 * https://doc.weixin.qq.com/doc/info?c=d
 * e=f&g=h
 */

function getQueryV2(url, key) {
  var val = null;
  var parsed = parseUrl(url);
  val = parsed.query[key];

  if (!val) {
    try {
      val = parse(url)[key];
    } catch (e) {}
  }

  return typeof val === 'string' ? val : null;
}
function addOrUpdateQuery(url, params) {
  var parsed = parseUrl(url);

  var query = _objectSpread$1(_objectSpread$1({}, parsed.query), params);

  return stringifyUrl(_objectSpread$1(_objectSpread$1({}, parsed), {}, {
    query: query
  }));
}

function getCookie(key) {
  if (typeof document === 'undefined') {
    return null;
  }

  var reg = new RegExp("(?:^|;+|\\s+)".concat(key, "=([^;]*)"));
  var result = document.cookie.match(reg);
  return (!result ? null : result[1]) || null;
}
function setCookie(name, value, days) {
  if (typeof document === 'undefined') {
    return null;
  }

  var expires = '';

  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=".concat(date.toUTCString());
  }

  document.cookie = "".concat(name, "=").concat(value || '').concat(expires, "; path=/");
}

var miniProgramSessionStorageKeymap = {
  // 企业微盘小程序
  wx92e25c25a75c927a: 'WEDRIVE_MP_SESSION',
  // 微文档小程序
  wx086c4c5c0dc9e424: 'WEDOC_MP_SESSION'
};
var Constants = {
  xsrfCookieNames: ['wedoc_sid', // 新版 openid 登录态
  'wedrive_sid', // 老版 vid 登录态
  'tdoc_sid' // 目前只看到团队形态-微文档模板中心还在用这一套，微文档是支持前两套登录态的
  ],
  xsrfCookieNameMiniProgram: 'sid',
  miniProgramSessionStorageKeymap: miniProgramSessionStorageKeymap,
  xsrfQueryName: 'sid',
  xsrfFlag: 'wedoc_xsrf',
  whitelistDomains: ['doc.weixin.qq.com', 'drive.weixin.qq.com', 'board.weixin.qq.com']
};
function isSameOriginRequest(url) {
  var hostIndex = url.indexOf('//'); // 如果不包含协议，则是相对路径调用，是同源

  if (hostIndex === -1) {
    return true;
  }

  var hostStart = hostIndex + 2; // 判断 cgi 是否和当前页面相同域名

  var hostname = getHostName();
  if (hostname) return assertDomain(url, hostname, hostStart); // 如果取不到 hostname (例如小程序), 则判断 cgi 域名是否在白名单中

  for (var i = 0; i < Constants.whitelistDomains.length; i++) {
    var domain = Constants.whitelistDomains[i];

    if (assertDomain(url, domain, hostStart)) {
      return true;
    }
  }

  return false;
} // 判断 url 是否特定 domain

function assertDomain(url, domain, hostStart) {
  return url.slice(hostStart, domain.length + hostStart) === domain;
} // 这里有两种可选的方案，目前采用的是黑名单制
// 1. 白名单：列出广研的 CGI，其他的都不拦截，涉及到的可能有 webdisk, txdoc, wedoc, comment, etc. 比较多，后面每次新增都有维护成本
// 2. 黑名单：之前 doc.weixin.qq.com 的请求全加上，实践中发现只有 sheet /websocket/ 会与 sid 参数名冲突，供参考


function isEnterpriseCGI(url) {
  var blacklist = ['/websocket/', '/info/report'];

  for (var _i = 0, _blacklist = blacklist; _i < _blacklist.length; _i++) {
    var item = _blacklist[_i];

    if (url.indexOf(item) !== -1) {
      return false;
    }
  }

  return true;
}
function isEnterpriseDomain() {
  // 如果是小程序，则认为是 b 端文档
  if (isMiniProgram()) {
    return true;
  }

  return Constants.whitelistDomains.indexOf(getHostName()) > -1;
}
function getXsrfToken() {
  if (isMiniProgram()) {
    var _getGlobal$getAccount, _getGlobal$getAccount2, _getGlobal;

    // 小程序里没有 cookie, 融合文档把 sid 相关字段存在小程序的 storage 中
    var _ref = (_getGlobal$getAccount = (_getGlobal$getAccount2 = (_getGlobal = getGlobal()).getAccountInfoSync) === null || _getGlobal$getAccount2 === void 0 ? void 0 : _getGlobal$getAccount2.call(_getGlobal).miniProgram) !== null && _getGlobal$getAccount !== void 0 ? _getGlobal$getAccount : {},
        appId = _ref.appId;

    if (typeof appId === 'string') {
      var storageKey = Constants.miniProgramSessionStorageKeymap[appId];

      if (storageKey) {
        var _session$Constants$xs;

        var session = getGlobal().getStorageSync(storageKey);
        return (_session$Constants$xs = session === null || session === void 0 ? void 0 : session[Constants.xsrfCookieNameMiniProgram]) !== null && _session$Constants$xs !== void 0 ? _session$Constants$xs : '';
      }
    }

    return '';
  }

  for (var i = 0; i < Constants.xsrfCookieNames.length; i++) {
    var sid = getCookie(Constants.xsrfCookieNames[i]);

    if (sid) {
      return sid;
    }
  }

  return '';
}
/**
 * 获取企微客户端的包类型, 从4.0.8的mac客户端开始有这个字段
 * 外发包(众测、发布包）：DistType/publish
 * 内部包：DistType/dev
 */

function getWecomDistType() {
  var wecomDistTypeReg = new RegExp("DistType\\/(publish|dev)", 'i');
  var wecomDistType = wecomDistTypeReg.exec(navigator.userAgent);
  return wecomDistType === null || wecomDistType === void 0 ? void 0 : wecomDistType[1];
}
function isWecomDev() {
  return getWecomDistType() === 'dev';
}

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function enterpriseXsrfInterceptor(config) {
  var _config$method, _addOrUpdateQuery;

  // 仅B端
  if (!isEnterpriseDomain()) {
    return config;
  }

  var method = (_config$method = config.method) === null || _config$method === void 0 ? void 0 : _config$method.toUpperCase();

  if (method !== 'POST') {
    return config;
  } // 仅同域名


  if (typeof config.url !== 'string' || !isSameOriginRequest(config.url)) {
    return config;
  } // 判断是否广研接口


  if (!isEnterpriseCGI(config.url)) {
    return config;
  } // 如果已经有 sid 参数了，并且不是我们自己的 xsrf token, 不处理;
  // 如果有 sid 参数，并且是我们自己的 xsrf token, 可能是上游重播了这个参数，要取最新的覆盖掉


  var sidInUrl = getQuery(config.url, Constants.xsrfQueryName);
  var isOurSid = getQuery(config.url, Constants.xsrfFlag);

  if (sidInUrl && !isOurSid) {
    log("sid \u53C2\u6570\u5DF2\u5B58\u5728 \u4E0D\u5904\u7406 url=".concat(config.url, " sid=").concat(sidInUrl));
    return config;
  }

  var xsrfToken = '';

  try {
    // 先取新票据的 wedoc_sid, 如果没有的话，用旧票据的 wedrive_sid
    xsrfToken = encodeURIComponent(getXsrfToken());
  } catch (e) {// do nothing
  }

  var url = addOrUpdateQuery(config.url, (_addOrUpdateQuery = {}, _defineProperty(_addOrUpdateQuery, Constants.xsrfQueryName, xsrfToken), _defineProperty(_addOrUpdateQuery, Constants.xsrfFlag, '1'), _addOrUpdateQuery));
  return _objectSpread(_objectSpread({}, config), {}, {
    url: url
  });
}

var XhrInterceptor = /*#__PURE__*/function () {
  function XhrInterceptor() {
    _classCallCheck(this, XhrInterceptor);

    _defineProperty(this, "hooks", []);

    if (typeof XMLHttpRequest === 'undefined') {
      return;
    }

    var xhrOpen = XMLHttpRequest.prototype.open;
    var hooks = this.hooks;

    XMLHttpRequest.prototype.open = function (method, url) {
      var _ref;

      var args = {
        method: method,
        url: url
      };
      hooks.forEach(function (hook) {
        args = hook(args);
      }); // https://stackoverflow.com/questions/70879794/xhr-interceptor-in-typescript/70881563#70881563

      for (var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        rest[_key - 2] = arguments[_key];
      }

      (_ref = xhrOpen).call.apply(_ref, [this, args.method, args.url].concat(rest));
    };
  }

  _createClass(XhrInterceptor, [{
    key: "use",
    value: function use(hook) {
      if (this.hooks.indexOf(hook) === -1) {
        this.hooks.push(hook);
      }
    }
  }, {
    key: "eject",
    value: function eject(hook) {
      this.hooks.splice(this.hooks.indexOf(hook), 1);
    }
  }]);

  return XhrInterceptor;
}();

var xhrInterceptor = new XhrInterceptor();

function addEnterpriseXsrfInterceptor() {
  xhrInterceptor.use(enterpriseXsrfInterceptor);
}

var getHttpError = function getHttpError(resp) {
  var _resp$response;

  var status = resp === null || resp === void 0 ? void 0 : (_resp$response = resp.response) === null || _resp$response === void 0 ? void 0 : _resp$response.status;

  if (typeof status === 'number' && (status < 200 || status >= 300)) {
    var _resp$response2;

    return {
      msg: (resp === null || resp === void 0 ? void 0 : resp.message) || (resp === null || resp === void 0 ? void 0 : (_resp$response2 = resp.response) === null || _resp$response2 === void 0 ? void 0 : _resp$response2.statusText) || '网络错误',
      code: status || 0
    };
  }

  return undefined;
};

var getTdocSvrError = function getTdocSvrError(resp) {
  var _resp$data, _resp$data2, _resp$data3, _resp$data4, _resp$data5, _resp$data6;

  var errcode = 0;

  if (typeof (resp === null || resp === void 0 ? void 0 : (_resp$data = resp.data) === null || _resp$data === void 0 ? void 0 : _resp$data.cgicode) === 'number' && (resp === null || resp === void 0 ? void 0 : (_resp$data2 = resp.data) === null || _resp$data2 === void 0 ? void 0 : _resp$data2.cgicode) !== 0 && !errcode) {
    errcode = resp.data.cgicode;
  } else if (typeof (resp === null || resp === void 0 ? void 0 : (_resp$data3 = resp.data) === null || _resp$data3 === void 0 ? void 0 : _resp$data3.ret) === 'number' && (resp === null || resp === void 0 ? void 0 : (_resp$data4 = resp.data) === null || _resp$data4 === void 0 ? void 0 : _resp$data4.ret) !== 0 && !errcode) {
    errcode = resp.data.ret;
  } else if (typeof (resp === null || resp === void 0 ? void 0 : (_resp$data5 = resp.data) === null || _resp$data5 === void 0 ? void 0 : _resp$data5.retcode) === 'number' && (resp === null || resp === void 0 ? void 0 : (_resp$data6 = resp.data) === null || _resp$data6 === void 0 ? void 0 : _resp$data6.retcode) !== 0 && !errcode) {
    errcode = resp.data.retcode;
  }

  if (errcode) {
    var _resp$data7;

    return {
      msg: typeof (resp === null || resp === void 0 ? void 0 : (_resp$data7 = resp.data) === null || _resp$data7 === void 0 ? void 0 : _resp$data7.msg) === 'string' ? resp.data.msg : undefined,
      code: errcode
    };
  }

  return undefined;
};

var getWecomSvrError = function getWecomSvrError(resp) {
  var _resp$headers;

  if (resp !== null && resp !== void 0 && (_resp$headers = resp.headers) !== null && _resp$headers !== void 0 && _resp$headers['error-code'] && resp.headers['error-code'] !== '0') {
    return {
      msg: resp.headers['error-code'],
      code: resp.headers['error-code']
    };
  }

  return undefined;
};

var getGySvrError = function getGySvrError(resp) {
  var _resp$data8, _resp$data8$head, _resp$data9, _resp$data9$head;

  if (typeof (resp === null || resp === void 0 ? void 0 : (_resp$data8 = resp.data) === null || _resp$data8 === void 0 ? void 0 : (_resp$data8$head = _resp$data8.head) === null || _resp$data8$head === void 0 ? void 0 : _resp$data8$head.ret) === 'number' && (resp === null || resp === void 0 ? void 0 : (_resp$data9 = resp.data) === null || _resp$data9 === void 0 ? void 0 : (_resp$data9$head = _resp$data9.head) === null || _resp$data9$head === void 0 ? void 0 : _resp$data9$head.ret) !== 0) {
    var _resp$data10, _resp$data10$head;

    return {
      msg: typeof (resp === null || resp === void 0 ? void 0 : (_resp$data10 = resp.data) === null || _resp$data10 === void 0 ? void 0 : (_resp$data10$head = _resp$data10.head) === null || _resp$data10$head === void 0 ? void 0 : _resp$data10$head.msg) === 'string' ? resp.data.head.msg : undefined,
      code: resp.data.head.ret
    };
  }

  return undefined;
};

var getCgiPath = function getCgiPath(resp) {
  var _resp$data11, _resp$data11$head, _resp$request;

  // 广研接口直接用cgi字段
  if (typeof (resp === null || resp === void 0 ? void 0 : (_resp$data11 = resp.data) === null || _resp$data11 === void 0 ? void 0 : (_resp$data11$head = _resp$data11.head) === null || _resp$data11$head === void 0 ? void 0 : _resp$data11$head.cgi) === 'string') {
    return resp.data.head.cgi;
  } // 优先用responseURL


  if (typeof (resp === null || resp === void 0 ? void 0 : (_resp$request = resp.request) === null || _resp$request === void 0 ? void 0 : _resp$request.responseURL) === 'string') {
    try {
      return new URL(resp.request.responseURL).pathname;
    } catch (e) {
      console.error('getCgiPath failed', e);
    }
  } // 兜底使用config.url


  try {
    var _resp$config;

    return new URL(resp === null || resp === void 0 ? void 0 : (_resp$config = resp.config) === null || _resp$config === void 0 ? void 0 : _resp$config.url).pathname;
  } catch (e) {
    console.error('getCgiPath failed', e);
  }

  return undefined;
};
var getCgiFunc = function getCgiFunc(resp) {
  var _ref = (resp === null || resp === void 0 ? void 0 : resp.config) || {},
      data = _ref.data,
      params = _ref.params,
      url = _ref.url;

  var func = undefined;

  if (typeof data === 'string' && !func) {
    func = getQueryV2(data, 'func');
  }

  if (_typeof(data) === 'object' && !func) {
    func = data.func;
  }

  if (typeof params === 'string' && !func) {
    func = getQueryV2(params, 'func');
  }

  if (_typeof(params) === 'object' && !func) {
    func = params.func;
  }

  if (typeof url === 'string' && !func) {
    func = getQueryV2(url, 'func');
  }

  return func && String(func);
};
var parseXhrError = function parseXhrError(resp) {
  var err = getTdocSvrError(resp) || getGySvrError(resp) || getWecomSvrError(resp) || getHttpError(resp);

  if (!err) {
    return undefined;
  }

  return {
    code: err.code,
    msg: err.msg,
    path: getCgiPath(resp),
    func: getCgiFunc(resp)
  };
};

function cgiLocalLogInterceptor(options, config) {
  if (options.blackList) {
    var isInBlackList = options.blackList.some(function (cgi) {
      var url = "".concat(config.url);
      return url.indexOf(cgi) !== -1;
    });

    if (isInBlackList) {
      return config;
    }
  }

  try {
    console.log("".concat(options.prefix, " [cgi-log] url=").concat(config.url));
    localLog("".concat(options.prefix, " [cgi-log] url=").concat(config.url));
  } catch (e) {
    console.error('cgiLocalLogInterceptor fail: ', e);
  }

  return config;
}
function initCgiLocalLogInterceptor(options) {
  var distType = getWecomDistType(); // 仅企微桌面端

  if (!distType) {
    console.warn('非企微桌面端，跳过');
    return null;
  } // 默认生产环境不打日志, 量太大担心影响性能


  if (!options.enableLocalLogInProduction && !isWecomDev()) {
    console.warn('非蓝盾包，跳过');
    return null;
  }

  return cgiLocalLogInterceptor.bind({}, options);
}

function addLocalLogCgiInterceptor(options) {
  var interceptor = initCgiLocalLogInterceptor(options);
  if (!interceptor) return;
  xhrInterceptor.use(interceptor);
}

// 获取用户身份唯一id(vid或openid)
var VID_KEY$1 = 'wedrive_uin';
var UID_KEY$1 = 'uid'; // 企微内嵌环境下, uid必然等于vid

var OPENID_KEY$1 = 'wedoc_openid';
function getUserId() {
  var cookieVid = getCookie(VID_KEY$1);
  var cookieOpenid = getCookie(OPENID_KEY$1);
  var cookieUid = getCookie(UID_KEY$1); // 某些场景下, 页面可能只有uid票据(如端内从扫码登录页重定向到apply_page), 没有wedrive/wedoc系列的广研票据
  // 此时登录态还是有效的，需要改用uid校验

  var rdgzKeyExist = !!(cookieVid || cookieOpenid);
  return {
    openid: cookieOpenid,
    vid: rdgzKeyExist ? cookieVid : cookieUid
  };
}

var VID_KEY = 'wedrive_uin';
var UID_KEY = 'uid'; // 企微内嵌环境下, uid必然等于vid

var UID_KEY2 = 'tdoc_uid'; // openid环境下的文档侧用户id

var OPENID_KEY = 'wedoc_openid';
function getCubeUserId() {
  var cookieVid = getCookie(VID_KEY);
  var cookieOpenid = getCookie(OPENID_KEY);
  var cookieUid = getCookie(UID_KEY);
  var cookieUid2 = getCookie(UID_KEY2);
  return cookieOpenid || cookieUid2 || cookieVid || cookieUid || undefined;
}
function getCubePlatform() {
  var _navigator = navigator,
      userAgent = _navigator.userAgent;
  var isiOS = !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // 匹配iOS系统

  var isAndroid = userAgent.indexOf('Android') > -1 || userAgent.indexOf('Adr') > -1; // 匹配Android系统

  var isWindows = userAgent.indexOf('Windows') > -1; // 匹配Windows系统

  var isMac = userAgent.indexOf('Mac OS X') > -1 && !isiOS; // 匹配Mac系统

  if (isiOS) {
    return 'ios';
  }

  if (isAndroid) {
    return 'android';
  }

  if (isWindows) {
    return 'win';
  }

  if (isMac) {
    return 'mac';
  }

  return 'unknown';
}
function getCubeWeixinWorkVersion() {
  function getWeworkVersion() {
    var match = navigator.userAgent.toLowerCase().match(/wxwork\/([0-9.]*)/);
    return match ? match[1] : '';
  }

  var str = getWeworkVersion();

  if (/wxworkQt/.test(navigator.userAgent)) {
    str += '-qt';
  }

  return str;
}
function getCubeFileType() {
  var _windowAsAny$basicCli, _windowAsAny$basicCli2, _windowAsAny$basicCli3, _windowAsAny$clientVa;

  var windowAsAny = window;
  return ((_windowAsAny$basicCli = windowAsAny.basicClientVars) === null || _windowAsAny$basicCli === void 0 ? void 0 : (_windowAsAny$basicCli2 = _windowAsAny$basicCli.docInfo) === null || _windowAsAny$basicCli2 === void 0 ? void 0 : (_windowAsAny$basicCli3 = _windowAsAny$basicCli2.padInfo) === null || _windowAsAny$basicCli3 === void 0 ? void 0 : _windowAsAny$basicCli3.padType) || ((_windowAsAny$clientVa = windowAsAny.clientVars) === null || _windowAsAny$clientVa === void 0 ? void 0 : _windowAsAny$clientVa.padType) || // 如果都没有，用pathname的第一个代替
  location.pathname.split('/').filter(function (segment) {
    return segment !== '';
  }).shift();
}
function getCubeDocId() {
  var _windowAsAny$basicCli4, _windowAsAny$basicCli5, _windowAsAny$basicCli6, _windowAsAny$clientVa2;

  var windowAsAny = window;
  return ((_windowAsAny$basicCli4 = windowAsAny.basicClientVars) === null || _windowAsAny$basicCli4 === void 0 ? void 0 : (_windowAsAny$basicCli5 = _windowAsAny$basicCli4.docInfo) === null || _windowAsAny$basicCli5 === void 0 ? void 0 : (_windowAsAny$basicCli6 = _windowAsAny$basicCli5.padInfo) === null || _windowAsAny$basicCli6 === void 0 ? void 0 : _windowAsAny$basicCli6.padId) || ((_windowAsAny$clientVa2 = windowAsAny.clientVars) === null || _windowAsAny$clientVa2 === void 0 ? void 0 : _windowAsAny$clientVa2.padId);
}
function sendCubeRequest(params) {
  var r = new XMLHttpRequest();
  r.open('POST', 'https://cube.weixinbridge.com/cube/report/reportbizdata?f=json');
  r.send("report_items=".concat(JSON.stringify(params)));
}
var cubeThrottleTimer = null;
var cubeQueue = []; // 简单的全景上报，支持节流

function cube(params) {
  var throttle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  if (typeof window === 'undefined') return; // 维度字段必填

  var baseParams = {
    action: '',
    biz: '',
    errMsg: '',
    doctype: getCubeFileType(),
    platform: getCubePlatform(),
    pathname: location.pathname || '',
    extra1: getCubeDocId(),
    extra3: window.navigator.userAgent,
    uin: getCubeUserId(),
    time: Math.round(Date.now() / 1000),
    // 不能覆盖
    biz_id: 7199,
    // 不能覆盖，因为字段是固定的
    weixin_work_version: getCubeWeixinWorkVersion(),
    version: window.__globalReleaseVersion
  };
  var combineParams = Object.assign({}, baseParams, params);

  if (throttle === 0) {
    sendCubeRequest([combineParams]);
  } else {
    cubeQueue.push(combineParams);

    if (cubeThrottleTimer) {
      return;
    }

    cubeThrottleTimer = window.setTimeout(function () {
      console.log("send cube request from queue, length:".concat(cubeQueue.length, "}"));
      sendCubeRequest(cubeQueue);
      cubeQueue = [];
      cubeThrottleTimer = null;
    }, throttle);
  }
}
// 将object的string内容裁剪到指定长度
function substrObject(obj) {
  var itemMaxLen = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1024;
  var oriDepthMax = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 4;
  var oriEachMax = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 2;
  var oriObjList = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var depthMax = oriDepthMax;
  var eachMax = oriEachMax;
  var objList = oriObjList;
  if (!obj) return obj;

  var type = _typeof(obj);

  if (type === 'function') {
    return '[Function]';
  }

  if (type === 'object') {
    if (depthMax === -1) {
      return '[Object]';
    }

    if (indexOf(objList, obj) !== -1) {
      return '[Circular]';
    }

    if (obj instanceof Error) {
      return "Error: ".concat(obj.message);
    }

    var isArr = isArray(obj);
    var data = isArr ? [] : {};
    if (!objList) objList = [];
    objList.push(obj);
    depthMax = typeof depthMax === 'number' ? depthMax : 5;
    eachMax || (eachMax = 20);
    var num = 0;
    forOwn(obj, function (val, key) {
      if (!isArr || num < eachMax) {
        num += 1;
        var value = substrObject(val, itemMaxLen, depthMax - 1, eachMax, objList);
        if (isArr) data.push(value);else data[key] = value;
      }
    });

    if (isArr && obj.length > eachMax) {
      data.push("[!!skip log:".concat(obj.length - eachMax, "/").concat(obj.length, "...]"));
    }

    return data;
  }

  if (type === 'string') {
    return obj.length > itemMaxLen ? "".concat(obj.substr(0, itemMaxLen - 12), "[sub log...]") : obj;
  }

  return obj;
}

var RELOAD_KEY = 'lastCheckUserReloadTime';
var RELOAD_COUNT_KEY = 'checkUserReloadCount';
var MAX_RELOAD_COUNT = 3;
var RELOAD_TIME_GAP = 5 * 60 * 1000; // 5min内不重新刷新

var isApplyPage = function isApplyPage() {
  return typeof location !== 'undefined' && location.pathname === '/txdoc/apply_page';
};

var isWxwork = /wxwork/.test(typeof navigator === 'undefined' ? '' : navigator.userAgent);

function isMobile() {
  if (typeof navigator === 'undefined') {
    return false;
  } // 与后台判断ua的逻辑保持一致


  var isWxdrive = /(wxdrive)/i.test(navigator.userAgent);

  if (/(mobile)/i.test(navigator.userAgent) && !isWxdrive) {
    return true;
  }

  if (/(pad)/i.test(navigator.userAgent) && !isWxdrive) {
    return true;
  }

  return false;
}

function resetReloadCount() {
  if (typeof localStorage === 'undefined') {
    return;
  }

  localStorage.setItem(RELOAD_COUNT_KEY, '0');
}

function getReloadCount() {
  if (typeof localStorage === 'undefined') {
    return 0;
  }

  var count = +(localStorage.getItem(RELOAD_COUNT_KEY) || '0');
  return isNaN(count) ? 0 : count;
}

function recordReloadCount() {
  if (typeof localStorage === 'undefined') {
    return;
  }

  var count = getReloadCount();
  localStorage.setItem(RELOAD_COUNT_KEY, "".concat(count + 1));
}

var delay = function delay(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
};

function clearCookieWithDomain(key, domain) {
  document.cookie = "".concat(key, "=clear; expires=Sun, 31 Dec 2017 12:00:00 UTC; path=/;Domain=").concat(domain);
} // 清除身份相关cookie，准备重新登录


function clearAuthCookie() {
  if (typeof document === 'undefined') {
    return;
  }

  var prefixes = ['wedrive_', 'wedoc_', 'tdoc_', 'uid'];
  var keys = document.cookie.split(';').map(function (kv) {
    return kv.split('=')[0].trim();
  }).filter(function (key) {
    return prefixes.some(function (prefix) {
      return key.startsWith(prefix);
    });
  });
  var domains = ['.weixin.qq.com', 'weixin.qq.com', '.doc.weixin.qq.com', 'doc.weixin.qq.com'];
  keys.forEach(function (key) {
    domains.forEach(function (domain) {
      clearCookieWithDomain(key, domain);
    });
  });
}

function clearAuthAndReload(_x, _x2, _x3, _x4) {
  return _clearAuthAndReload.apply(this, arguments);
}

function _clearAuthAndReload() {
  _clearAuthAndReload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(userId, realUserId, errMsg, onIdentityCorrected) {
    var lastReloadTime, now, reloadCount, _window$tdocs, _window$tdocs$docLogi;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(typeof localStorage === 'undefined')) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return");

          case 2:
            lastReloadTime = +(localStorage.getItem(RELOAD_KEY) || ''); // 上一个页面标记 reload 后可能还没 reload 成功就跳到权限申请页了，这里跳过刷新时间的校验，用下面的刷新次数兜底

            if (!(!isNaN(lastReloadTime) && !isApplyPage())) {
              _context.next = 9;
              break;
            }

            // 检查一下上次刷新的时间，如果小于5min定义为连续刷新，跳过
            now = Date.now();

            if (!(now - lastReloadTime < RELOAD_TIME_GAP)) {
              _context.next = 9;
              break;
            }

            cube({
              action: 'reloadLessThan5min'
            });
            log("reload less than ".concat(RELOAD_TIME_GAP, "s, ignore"));
            return _context.abrupt("return");

          case 9:
            reloadCount = getReloadCount();

            if (!(reloadCount > MAX_RELOAD_COUNT)) {
              _context.next = 14;
              break;
            }

            cube({
              action: 'reloadTimeReachLimit'
            });
            log("reload more than ".concat(MAX_RELOAD_COUNT, ", ignore"));
            return _context.abrupt("return");

          case 14:
            cube({
              action: 'notCurrentUser',
              extra1: userId,
              extra2: realUserId,
              errMsg: errMsg
            });
            log("notCurrentUser, wecom=".concat(realUserId, ", cookie=").concat(userId));
            localStorage.setItem(RELOAD_KEY, "".concat(Date.now()));
            recordReloadCount(); // 确保上报发出

            _context.next = 20;
            return delay(100);

          case 20:
            // 清cookie
            clearAuthCookie();
            _context.prev = 21;
            _context.next = 24;
            return (_window$tdocs = window.tdocs) === null || _window$tdocs === void 0 ? void 0 : (_window$tdocs$docLogi = _window$tdocs.docLogin) === null || _window$tdocs$docLogi === void 0 ? void 0 : _window$tdocs$docLogi.call(_window$tdocs);

          case 24:
            _context.next = 29;
            break;

          case 26:
            _context.prev = 26;
            _context.t0 = _context["catch"](21);
            log("docLogin err, continue to reload: ".concat(_context.t0));

          case 29:
            if (typeof onIdentityCorrected === 'function') {
              onIdentityCorrected();
            } else {
              // 刷新
              location.reload();
            }

          case 30:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[21, 26]]);
  }));
  return _clearAuthAndReload.apply(this, arguments);
}

function checkUserIdFromWecom(_x5, _x6) {
  return _checkUserIdFromWecom.apply(this, arguments);
}
/**
 * 4.0.12开始，win切换企业时会进行browser进程保活
 * 为了避免切企业后，进程没有刷新导致串数据，这里加一个校验身份逻辑
 * @param onIdentityCorrected 身份纠正后执行的回调, 默认行为是刷新页面
 */


function _checkUserIdFromWecom() {
  _checkUserIdFromWecom = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(cookieUserId, useOpenid) {
    var cstRes, wecomUserId, errMsg;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!(typeof window === 'undefined')) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return", {
              result: true,
              wecomUserId: '',
              errMsg: ''
            });

          case 2:
            _context2.next = 4;
            return window.tdocs.getLoginCst({
              useOpenid: useOpenid ? 1 : 0
            });

          case 4:
            cstRes = _context2.sent;
            wecomUserId = useOpenid ? cstRes.openid : cstRes.vid;
            errMsg = "".concat(useOpenid ? 'openid' : 'vid', " inconsistent, cookie=").concat(cookieUserId, ", wecom=").concat(wecomUserId, ".");
            return _context2.abrupt("return", {
              result: cookieUserId === wecomUserId,
              wecomUserId: wecomUserId,
              errMsg: errMsg
            });

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _checkUserIdFromWecom.apply(this, arguments);
}

function checkIsCurrentUser(_x7) {
  return _checkIsCurrentUser.apply(this, arguments);
}

function _checkIsCurrentUser() {
  _checkIsCurrentUser = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(onIdentityCorrected) {
    var _window$tdocs2;

    var userRes, sameUser, isCheckResEmpty, errMsg, cookieUserId, wecomUserId, checkRes, _checkRes, _window, _window$clientVars, vid, _checkRes2;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!(typeof window === 'undefined')) {
              _context3.next = 2;
              break;
            }

            return _context3.abrupt("return", true);

          case 2:
            if (isWxwork) {
              _context3.next = 5;
              break;
            }

            log('not wxwork, skip');
            return _context3.abrupt("return");

          case 5:
            if (!isMobile()) {
              _context3.next = 8;
              break;
            }

            log('mobile, skip');
            return _context3.abrupt("return");

          case 8:
            if ((_window$tdocs2 = window.tdocs) !== null && _window$tdocs2 !== void 0 && _window$tdocs2.getLoginCst) {
              _context3.next = 11;
              break;
            }

            log('not support getLoginCst, skip');
            return _context3.abrupt("return");

          case 11:
            _context3.prev = 11;
            userRes = getUserId();

            if (!(!userRes.openid && !userRes.vid)) {
              _context3.next = 16;
              break;
            }

            log('empty userId, check next time');
            return _context3.abrupt("return");

          case 16:
            sameUser = true;
            isCheckResEmpty = false; // jsapi没有返回身份信息
            // 拼接用于上报的信息

            errMsg = '';
            cookieUserId = '';
            wecomUserId = ''; // 校验openid

            if (!userRes.openid) {
              _context3.next = 30;
              break;
            }

            _context3.next = 24;
            return checkUserIdFromWecom(userRes.openid, true);

          case 24:
            checkRes = _context3.sent;
            sameUser = sameUser && checkRes.result;
            isCheckResEmpty = !checkRes.wecomUserId;

            if (!checkRes.result) {
              errMsg += "".concat(checkRes.errMsg, "|");
              cookieUserId += "".concat(userRes.openid, "|");
              wecomUserId += "".concat(checkRes.wecomUserId, "|");
            }

            if (!isCheckResEmpty) {
              _context3.next = 30;
              break;
            }

            return _context3.abrupt("return");

          case 30:
            if (!userRes.vid) {
              _context3.next = 37;
              break;
            }

            _context3.next = 33;
            return checkUserIdFromWecom(userRes.vid, false);

          case 33:
            _checkRes = _context3.sent;
            sameUser = sameUser && _checkRes.result;
            isCheckResEmpty = !_checkRes.wecomUserId;

            if (!_checkRes.result) {
              errMsg += "".concat(_checkRes.errMsg, "|");
              cookieUserId += "".concat(userRes.vid, "|");
              wecomUserId += "".concat(_checkRes.wecomUserId, "|");
            }

          case 37:
            if (!isApplyPage()) {
              _context3.next = 45;
              break;
            }

            // 权限申请页特殊处理。因为他的页面数据是直出的，等到页面执行时再判断 cookie 身份存在漏判的情况
            vid = (_window = window) === null || _window === void 0 ? void 0 : (_window$clientVars = _window.clientVars) === null || _window$clientVars === void 0 ? void 0 : _window$clientVars.operator_vid;

            if (!vid) {
              _context3.next = 45;
              break;
            }

            _context3.next = 42;
            return checkUserIdFromWecom(vid, false);

          case 42:
            _checkRes2 = _context3.sent;
            // 权限页单纯看直出 vid, 不需要结合上面 cookie 的判断结果
            sameUser = _checkRes2.result;
            isCheckResEmpty = !_checkRes2.wecomUserId;

          case 45:
            if (!(!sameUser && !isCheckResEmpty)) {
              _context3.next = 50;
              break;
            }

            _context3.next = 48;
            return clearAuthAndReload(cookieUserId, wecomUserId, errMsg, onIdentityCorrected);

          case 48:
            _context3.next = 52;
            break;

          case 50:
            resetReloadCount();
            log('checkIsCurrentUser: same user=', "".concat(userRes.openid, "|").concat(userRes.vid));

          case 52:
            _context3.next = 57;
            break;

          case 54:
            _context3.prev = 54;
            _context3.t0 = _context3["catch"](11);
            log('checkIsCurrentUser err: ', _context3.t0);

          case 57:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[11, 54]]);
  }));
  return _checkIsCurrentUser.apply(this, arguments);
}

var COOKIE_KEY = 'window_width';
var URL_QUERY_KEY = 'window_width';
var COOKIE_EXPIRE_DAYS = 30;
/**
 * 设置窗口宽度信息到 cookie
 */

function setWindowWidth() {
  if (typeof window === 'undefined') return;
  setCookie(COOKIE_KEY, "".concat(window.innerWidth), COOKIE_EXPIRE_DAYS);
}
/**
 * 获取窗口宽度信息，获取顺序：URL；cookie
 * @param url
 */


function getWindowWidth() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var windowWidth = 0;

  if (url.length) {
    windowWidth = Number(getQuery(url, URL_QUERY_KEY) || 0);
    if (windowWidth > 0) return windowWidth;
  }

  if (document.cookie.length) {
    windowWidth = Number(getCookie(COOKIE_KEY) || 0);
    if (windowWidth > 0) return windowWidth;
  }

  return windowWidth;
}

var TOOLBARMODE_STORAGE_KEY_PREFIX = 'env_wework_toolbar_mode';
/**
 * 品类
 */

var ToolbarModeDocType;

(function (ToolbarModeDocType) {
  ToolbarModeDocType["Doc"] = "doc";
  ToolbarModeDocType["Sheet"] = "sheet";
})(ToolbarModeDocType || (ToolbarModeDocType = {}));

var getToolbarModeCookieKey = function getToolbarModeCookieKey(doctype, userId) {
  var key = "".concat(doctype, "_").concat(TOOLBARMODE_STORAGE_KEY_PREFIX);

  if (userId) {
    key += "_".concat(userId);
  }

  return key;
};
/**
 * 设置工具栏模式到 cookie
 */


function setToolbarModeToCookie(mode, doctype, userId) {
  setCookie(getToolbarModeCookieKey(doctype, userId), mode);
}
/**
 * 从 cookie 读取工具栏模式
 */


function getToolbarModeFromCookie(doctype, userId) {
  return getCookie(getToolbarModeCookieKey(doctype, userId));
}

function sleep(time) {
  return new Promise(function (resolve) {
    return setTimeout(function () {
      resolve();
    }, time);
  });
}

function dontWaitFor(promise) {
  // Effective no-op.
  promise.then(function () {});
}

function formatBytes(bytes) {
  var withUnit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  if (!+bytes) return '0 B';
  var k = 1024;
  var sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  var i = Math.floor(Math.log(bytes) / Math.log(k)); // 需求，mb及以上保留一位小数

  var dm = i >= 2 ? 1 : 0; // parsefloat自动去0

  return "".concat(parseFloat((bytes / Math.pow(k, i)).toFixed(dm))).concat(withUnit ? " ".concat(sizes[i]) : '');
}

var isPad = function isPad() {
  return document.body.clientWidth >= 500;
};
var subscribeIsPad = function subscribeIsPad(callback) {
  var resize = function resize() {
    return callback(isPad());
  };

  callback(isPad());
  window.addEventListener('resize', resize);
  return function () {
    window.removeEventListener('resize', resize);
  };
};
var isPadAndAbrove418 = function isPadAndAbrove418() {
  return isPad() && ua.isWxWork && ua.isWxWorkVersionAboveOrEqual('4.1.8');
};
var subscribeIsPadAndAbrove418 = function subscribeIsPadAndAbrove418(callback) {
  callback(isPadAndAbrove418());

  var resize = function resize() {
    return callback(isPadAndAbrove418());
  };

  window.addEventListener('resize', resize);
  return function () {
    window.removeEventListener('resize', resize);
  };
};

var BIGINT_SUPPORT = typeof BigInt === 'function';
var ID_PREFIX_REGEX = /^(p|g)\./;
var bigints = {};

if (BIGINT_SUPPORT) {
  bigints[6] = BigInt(6);
  bigints[20] = BigInt(20);
  bigints[28] = BigInt(28);
  bigints[32] = BigInt(32);
  bigints[48] = BigInt(48);
  bigints[3050710] = BigInt(3050710);
  bigints[3050703] = BigInt(3050703); // kWeDriveUser

  bigints[3050704] = BigInt(3050704); // kWeDocUser
}
/**
 * @param id vid >> 48 = 6
 * @returns boolean
 */


function isVid(id) {
  if (!/^\d+$/.test(id)) return false;

  if (BIGINT_SUPPORT) {
    try {
      return BigInt(id) >> bigints[48] === bigints[6];
    } catch (e) {}
  } // 粗略判断法：
  // 0x6000000000000 ~ 0x60000ffffffff
  // 1688849860263936n ~ 1688854155231231n


  return id.length === 16 && id.substring(0, 5) === '16888';
}
/**
 * API创建的文档，创建者是APP
 * @param id appId >> 48 = 20
 * @returns boolean
 */

function isAppId(id) {
  if (!/^\d+$/.test(id)) return false;

  if (BIGINT_SUPPORT) {
    try {
      return BigInt(id) >> bigints[48] === bigints[20];
    } catch (e) {}
  } // 粗略判断法：
  // 0x14000000000000 ~ 0x140000ffffffff
  // 5629499534213120n ~ 5629503829180415n


  var prefix6 = id.substring(0, 6);
  return id.length === 16 && (prefix6 === '562949' || prefix6 === '562950');
}
/**
 * @param id uid >> 32 = 3050710(2e8cd6)
 * @returns boolean
 */

function isWedriveUid(id) {
  if (!/^\d+$/.test(id)) return false;

  if (BIGINT_SUPPORT) {
    try {
      return BigInt(id) >> bigints[32] === bigints[3050710];
    } catch (e) {}
  } // 粗略判断法：
  // 0x2e8cd600000000 ~ 0x2e8cd6ffffffff
  // 13102699679580160n ~ 13102703974547455n


  var prefix7 = id.substring(0, 7);
  return id.length === 16 && (prefix7 === '1310269' || prefix7 === '1310270');
}
function isWedriveUin(id) {
  if (!/^\d+$/.test(id)) return false;

  if (BIGINT_SUPPORT) {
    try {
      var highInt = BigInt(id) >> bigints[32];
      return highInt === bigints[3050703] || highInt === bigints[3050704];
    } catch (e) {}
  } // 粗略判断法：
  // 2e8ccf00000000 ~ 2e8cd0ffffffff
  // 13102669614809088n ~ 13102678204743679n


  var prefix7 = id.substring(0, 7);
  return id.length === 16 && (prefix7 === '1310266' || prefix7 === '1310267');
}
/**
 * @param id xid >> 48 = 28
 */

function isXid(id) {
  if (!/^\d+$/.test(id)) return false;

  if (BIGINT_SUPPORT) {
    try {
      return BigInt(id) >> bigints[48] === bigints[28];
    } catch (e) {}
  } // 粗略判断法：
  // 0x1c000000000000 ~ 0x1c0000ffffffff
  // 7881299347898368n ~ 7881303642865663n


  return id.length === 16 && id.substring(0, 4) === '7881';
}
function isWxTinyid(id) {
  return id.startsWith('14');
}
function isOpenId(id) {
  return !/^\d+$/.test(id === null || id === void 0 ? void 0 : id.replace(ID_PREFIX_REGEX, ''));
}

// 特性：企业微信团队，5629501042540346是它的vid，13102702706618269是它的uid
var isSpecialCreatorId = function isSpecialCreatorId(id) {
  return id === '5629501042540346' || id === '13102702706618269';
};
var getAppCreatorVid = function getAppCreatorVid() {
  var _window, _window$basicClientVa, _window$basicClientVa2, _window$basicClientVa3, _window2, _window2$clientVars;

  return ((_window = window) === null || _window === void 0 ? void 0 : (_window$basicClientVa = _window.basicClientVars) === null || _window$basicClientVa === void 0 ? void 0 : (_window$basicClientVa2 = _window$basicClientVa.docInfo) === null || _window$basicClientVa2 === void 0 ? void 0 : (_window$basicClientVa3 = _window$basicClientVa2.createInfo) === null || _window$basicClientVa3 === void 0 ? void 0 : _window$basicClientVa3.creatorId) || ((_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$clientVars = _window2.clientVars) === null || _window2$clientVars === void 0 ? void 0 : _window2$clientVars.creatorId) || '';
};
var getAppCreatorName = function getAppCreatorName() {
  var _window3, _window3$basicClientV, _window3$basicClientV2, _window3$basicClientV3, _window4, _window4$clientVars, _window5, _window5$basicClientV, _window5$basicClientV2, _window6, _window6$clientVars;

  // ast模块有问题，先暂时复制getAppCreatorVid的代码
  var vid = ((_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$basicClientV = _window3.basicClientVars) === null || _window3$basicClientV === void 0 ? void 0 : (_window3$basicClientV2 = _window3$basicClientV.docInfo) === null || _window3$basicClientV2 === void 0 ? void 0 : (_window3$basicClientV3 = _window3$basicClientV2.createInfo) === null || _window3$basicClientV3 === void 0 ? void 0 : _window3$basicClientV3.creatorId) || ((_window4 = window) === null || _window4 === void 0 ? void 0 : (_window4$clientVars = _window4.clientVars) === null || _window4$clientVars === void 0 ? void 0 : _window4$clientVars.creatorId) || '';

  if (isSpecialCreatorId(vid)) {
    return '企业微信团队';
  }

  var createInfo = (_window5 = window) === null || _window5 === void 0 ? void 0 : (_window5$basicClientV = _window5.basicClientVars) === null || _window5$basicClientV === void 0 ? void 0 : (_window5$basicClientV2 = _window5$basicClientV.docInfo) === null || _window5$basicClientV2 === void 0 ? void 0 : _window5$basicClientV2.createInfo;

  if (createInfo !== null && createInfo !== void 0 && createInfo.creatorCorpId && createInfo !== null && createInfo !== void 0 && createInfo.creatorNick) {
    return createInfo.creatorNick;
  }

  return ((_window6 = window) === null || _window6 === void 0 ? void 0 : (_window6$clientVars = _window6.clientVars) === null || _window6$clientVars === void 0 ? void 0 : _window6$clientVars.creatorNick) || '';
};

var isAndroidMallWebview = function isAndroidMallWebview(u) {
  var _window;

  var url = window.location.href || '';
  return u.isAndroid && ((_window = window) === null || _window === void 0 ? void 0 : _window.TenOfficeJSBridgeAndroid) && u.isWxWork && ( // 在模板商城里面的其他页跳过来 或 从客户端入口直接打开模板商城页面
  document.referrer.includes('/mall') || document.referrer === '') && url.includes('weixin.qq.com/mall');
};

function openUrlInWecom(vipUrl) {
  if (ua.isWxWork) {
    var _window$tdocs2;

    // 端内
    if (ua.isMac || ua.isWindows) {
      var _window2, _window2$WeixinJSBrid, _window2$WeixinJSBrid2;

      // mac 端内
      (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$WeixinJSBrid = _window2.WeixinJSBridge) === null || _window2$WeixinJSBrid === void 0 ? void 0 : (_window2$WeixinJSBrid2 = _window2$WeixinJSBrid.invoke) === null || _window2$WeixinJSBrid2 === void 0 ? void 0 : _window2$WeixinJSBrid2.call(_window2$WeixinJSBrid, 'wwapp.openUrl', {
        width: '960',
        // 需要指定宽高
        height: '680',
        forceInnerBrowser: 1,
        url: vipUrl
      });
      return;
    }

    if (isAndroidMallWebview(ua) && ua.isWxWorkVersionAboveOrEqual('4.1.2')) {
      var _window3;

      log('new androidMallWebview');
      (_window3 = window) === null || _window3 === void 0 ? void 0 : _window3.TenOfficeJSBridge.invoke({
        func: 'wwapp.tdoc.openDocLink',
        params: {
          url: vipUrl,
          target: 3
        }
      }).then(function (_ref) {
        var _ref$code = _ref.code,
            code = _ref$code === void 0 ? 0 : _ref$code;

        if (code !== 0) {
          var _window$tdocs;

          log('fail to invoke wwapp.tdoc.openDocLink');

          if ((_window$tdocs = window.tdocs) !== null && _window$tdocs !== void 0 && _window$tdocs.openUrl) {
            // 移动端端内
            log('try to invoke window.tdocs.openUrl');
            window.tdocs.openUrl({
              url: vipUrl,
              target: 3
            });
          }
        }
      });
      return;
    }

    if ((_window$tdocs2 = window.tdocs) !== null && _window$tdocs2 !== void 0 && _window$tdocs2.openUrl) {
      // 移动端端内
      window.tdocs.openUrl({
        url: vipUrl,
        target: 3
      });
      return;
    }

    log('无法调用相关jsapi，改为window.oppen');
    window.open(vipUrl);
    return;
  }
}
function openApplyUseUrl(url, from) {
  var urlObject = new URL(url);
  urlObject.searchParams.set('from', from);
  var vipUrl = urlObject.toString();
  log('openApplyUseUrl', vipUrl);

  if (ua.isWxWork) {
    openUrlInWecom(vipUrl);
    return;
  }

  if (ua.isMac || ua.isWindows) {
    // 端外pc
    var schema = "wxwork://openurl?url=".concat(encodeURIComponent(vipUrl));
    window.open(schema);
  } else {
    // 端外移动端
    window.open(vipUrl);
  }
}
function openVipUrl(url, from) {
  var urlObject = new URL(url);
  urlObject.searchParams.set('from', from);
  var vipUrl = urlObject.toString();
  log('openVipUrl', vipUrl);

  if (ua.isWxWork) {
    openUrlInWecom(vipUrl);
    return;
  }

  if (ua.isMac || ua.isWindows) {
    // 端外pc
    var schema = "wxwork://openurl?url=https%3A%2F%2Fwork.weixin.qq.com%2Fmall%2Fpage%3Fbar_bg%3DC18E27%2CA47921%26hide_more_btn%3Dtrue%26for_native%3Dtrue%26bar_cont%3DFFFFFF%2CFFFFFF%26statusbar_style%3Dlight%2Clight%26offid%3Dzd48gq0gtkulxpp%26offBizKey%3D4%26ww_vw%3D880%26ww_vh%3D640%26ww_uniq%3Dwork%2Fmall%2Fintro_wedoc%26from%3D".concat(from, "%23%2Fintro%2Fwedoc");
    window.open(schema);
  } else {
    // 端外移动端
    window.open(vipUrl);
  }
}
/**
 * @deprecated 不能确保有创建者的 vid
 */

function contactDocOwner(vid) {
  var creatorVid;

  if (isVid(vid)) {
    creatorVid = vid;
  } else {
    log('当前创建者id不是vid,无法唤起', vid);
    cube({
      action: 'capacityClickBtnFail',
      channel1: 'contactOwner',
      channel2: 'notVid'
    });
    return;
  }

  if (ua.isPC || ua.isMac) {
    // win这样调不通
    if (ua.isWxWork && ua.isMac) {
      var _window4, _window4$tdocs;

      // 端内
      if ((_window4 = window) !== null && _window4 !== void 0 && (_window4$tdocs = _window4.tdocs) !== null && _window4$tdocs !== void 0 && _window4$tdocs.openInBrowser) {
        window.tdocs.openInBrowser({
          url: "wxwork://message?uin=".concat(creatorVid)
        });
        return;
      }

      log('contactOwner fail: 缺少window.tdocs.openInBrowser');
      cube({
        action: 'capacityClickBtnFail',
        channel1: 'contactOwner',
        channel2: 'missOpenInBrowser'
      });
    } else {
      // 端外
      var url = "wxwork://message?uin=".concat(creatorVid);
      location.href = url;
    }
  } else {
    var _window$tdocs3;

    // 移动端唤起p rofile
    if ((_window$tdocs3 = window.tdocs) !== null && _window$tdocs3 !== void 0 && _window$tdocs3.viewProfile) {
      window.tdocs.viewProfile({
        vid: creatorVid
      });
      return;
    }

    log('contactOwner fail: 缺少window.tdocs.viewProfile');
    cube({
      action: 'capacityClickBtnFail',
      channel1: 'contactOwner',
      channel2: 'missViewProfile'
    });
  }
}

var isWikiShortcut = function isWikiShortcut() {
  var _ref, _window$clientVars$wi, _window$clientVars, _window$clientVars$wi2, _window$basicClientVa2, _window$basicClientVa3, _window$basicClientVa4;

  if (!window.clientVars && !window.basicClientVars) {
    var _location;

    console.warn('同步获取 wikifileid 可能不准');
    return /wikifileid=/.test(((_location = location) === null || _location === void 0 ? void 0 : _location.search) || '');
  }

  var shortcutIsDeleted = false;

  if (window.clientVars) {
    shortcutIsDeleted = !!window.clientVars.shortcutIsDeleted;
  } else if (window.basicClientVars) {
    var _window$basicClientVa;

    shortcutIsDeleted = !!((_window$basicClientVa = window.basicClientVars.docInfo) !== null && _window$basicClientVa !== void 0 && _window$basicClientVa.shortcutIsDeleted);
  }

  var fileId = (_ref = (_window$clientVars$wi = (_window$clientVars = window.clientVars) === null || _window$clientVars === void 0 ? void 0 : (_window$clientVars$wi2 = _window$clientVars.wikiInfo) === null || _window$clientVars$wi2 === void 0 ? void 0 : _window$clientVars$wi2.fileID) !== null && _window$clientVars$wi !== void 0 ? _window$clientVars$wi : (_window$basicClientVa2 = window.basicClientVars) === null || _window$basicClientVa2 === void 0 ? void 0 : (_window$basicClientVa3 = _window$basicClientVa2.docInfo) === null || _window$basicClientVa3 === void 0 ? void 0 : (_window$basicClientVa4 = _window$basicClientVa3.wikiInfo) === null || _window$basicClientVa4 === void 0 ? void 0 : _window$basicClientVa4.fileID) !== null && _ref !== void 0 ? _ref : '';
  return !shortcutIsDeleted && isWikiShortcutId(fileId);
};
function isWikiShortcutId(fileId) {
  return fileId.startsWith('w.') && fileId.includes('_l');
}
/**
 * 判断是否为文档在微盘但是快捷方式在知识库, 打开的时候 url 又没有 wikifileid 的场景
 * 此时品类即使没有在知识库内套壳打开，也不应该刷走(4.1.20 版本中间态兼容逻辑)
 * (需要在 opendoc 返回后再调用!!!)
 * @returns boolean
 */

var shouldDisableTryJumpToWiki = function shouldDisableTryJumpToWiki() {
  var _window, _window$clientVars2, _location2;

  var wikiInfo = (_window = window) === null || _window === void 0 ? void 0 : (_window$clientVars2 = _window.clientVars) === null || _window$clientVars2 === void 0 ? void 0 : _window$clientVars2.wikiInfo;
  var hasWikiFileId = /wikifileid=/.test(((_location2 = location) === null || _location2 === void 0 ? void 0 : _location2.search) || '');

  if (wikiInfo !== null && wikiInfo !== void 0 && wikiInfo.isWiki && isWikiShortcutId(wikiInfo === null || wikiInfo === void 0 ? void 0 : wikiInfo.fileID) && !hasWikiFileId) {
    return true;
  }
};
/**
 * @deprecated 无可奈何的情况下获取 wikiShortcutId，正道应该是在品类里等待 opendoc promise
 */

function lazyGetWikiShortcutId() {
  return _lazyGetWikiShortcutId.apply(this, arguments);
}

function _lazyGetWikiShortcutId() {
  _lazyGetWikiShortcutId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!window.clientVars) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", window.clientVars.wikiInfo.fileID);

          case 2:
            if (!window.basicClientVars) {
              _context.next = 4;
              break;
            }

            return _context.abrupt("return", window.basicClientVars.docInfo.wikiInfo.fileID);

          case 4:
            _context.next = 6;
            return new Promise(function (resolve) {
              return setTimeout(resolve, 100);
            });

          case 6:
            _context.next = 8;
            return lazyGetWikiShortcutId();

          case 8:
            return _context.abrupt("return", _context.sent);

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _lazyGetWikiShortcutId.apply(this, arguments);
}

// 取文档本体的知识库信息
var getOriginDocBasicClientVarsWikiInfo = function getOriginDocBasicClientVarsWikiInfo() {
  var _window2, _window2$basicClientV, _window2$basicClientV2, _window3, _window3$basicClientV, _window3$basicClientV2;

  return isWikiShortcut() ? (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$basicClientV = _window2.basicClientVars) === null || _window2$basicClientV === void 0 ? void 0 : (_window2$basicClientV2 = _window2$basicClientV.docInfo) === null || _window2$basicClientV2 === void 0 ? void 0 : _window2$basicClientV2.sourceFileInfo : (_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$basicClientV = _window3.basicClientVars) === null || _window3$basicClientV === void 0 ? void 0 : (_window3$basicClientV2 = _window3$basicClientV.docInfo) === null || _window3$basicClientV2 === void 0 ? void 0 : _window3$basicClientV2.wikiInfo;
};
var getOriginDocClientVarsWikiInfo = function getOriginDocClientVarsWikiInfo() {
  var _window4, _window4$clientVars, _window5, _window5$clientVars;

  return isWikiShortcut() ? (_window4 = window) === null || _window4 === void 0 ? void 0 : (_window4$clientVars = _window4.clientVars) === null || _window4$clientVars === void 0 ? void 0 : _window4$clientVars.sourceFileInfo : (_window5 = window) === null || _window5 === void 0 ? void 0 : (_window5$clientVars = _window5.clientVars) === null || _window5$clientVars === void 0 ? void 0 : _window5$clientVars.wikiInfo;
}; // 取当前打开的快捷方式的知识库信息

var getShortcutBasicClientVarsWikiInfo = function getShortcutBasicClientVarsWikiInfo() {
  var _window6, _window6$basicClientV, _window6$basicClientV2;

  return isWikiShortcut() ? (_window6 = window) === null || _window6 === void 0 ? void 0 : (_window6$basicClientV = _window6.basicClientVars) === null || _window6$basicClientV === void 0 ? void 0 : (_window6$basicClientV2 = _window6$basicClientV.docInfo) === null || _window6$basicClientV2 === void 0 ? void 0 : _window6$basicClientV2.wikiInfo : undefined;
};
var getShortcutClientVarsWikiInfo = function getShortcutClientVarsWikiInfo() {
  var _window7, _window7$clientVars;

  return isWikiShortcut() ? (_window7 = window) === null || _window7 === void 0 ? void 0 : (_window7$clientVars = _window7.clientVars) === null || _window7$clientVars === void 0 ? void 0 : _window7$clientVars.wikiInfo : undefined;
};
var getBasicClientVarsWikiInfo = function getBasicClientVarsWikiInfo() {
  return isWikiShortcut() ? getShortcutBasicClientVarsWikiInfo() : getOriginDocBasicClientVarsWikiInfo();
};
var getClientVarsWikiInfo = function getClientVarsWikiInfo() {
  return isWikiShortcut() ? getShortcutClientVarsWikiInfo() : getOriginDocClientVarsWikiInfo();
};
var isWikiEmbeded = function isWikiEmbeded() {
  var _location3;

  return /isWikiEmbedded=1/.test(((_location3 = location) === null || _location3 === void 0 ? void 0 : _location3.search) || '');
}; // 当前打开的是不是知识库文档，打开是的快捷方式就判断快捷方式，打开文档本体就判断本体

var isWikiDoc = function isWikiDoc() {
  var _getBasicClientVarsWi;

  // 如果内嵌打开就默认是知识库文档
  if (isWikiEmbeded()) {
    return true;
  }

  var _window8 = window,
      clientVars = _window8.clientVars;

  if (clientVars) {
    var _getClientVarsWikiInf;

    return !!((_getClientVarsWikiInf = getClientVarsWikiInfo()) !== null && _getClientVarsWikiInf !== void 0 && _getClientVarsWikiInf.isWiki);
  }

  return !!((_getBasicClientVarsWi = getBasicClientVarsWikiInfo()) !== null && _getBasicClientVarsWi !== void 0 && _getBasicClientVarsWi.isWiki);
}; // 文档本体是不是知识库文档

var isOriginDocWikiDoc = function isOriginDocWikiDoc() {
  var _getOriginDocBasicCli;

  var _window9 = window,
      clientVars = _window9.clientVars;

  if (clientVars) {
    var _getOriginDocClientVa;

    return !!((_getOriginDocClientVa = getOriginDocClientVarsWikiInfo()) !== null && _getOriginDocClientVa !== void 0 && _getOriginDocClientVa.isWiki);
  }

  return !!((_getOriginDocBasicCli = getOriginDocBasicClientVarsWikiInfo()) !== null && _getOriginDocBasicCli !== void 0 && _getOriginDocBasicCli.isWiki);
}; // 文档快捷方式是不是知识库文档，只有打开的是快捷方式链接才有效

var isShortCutWikiDoc = function isShortCutWikiDoc() {
  var _getShortcutBasicClie;

  var _window10 = window,
      clientVars = _window10.clientVars;

  if (clientVars) {
    var _getShortcutClientVar;

    return !!((_getShortcutClientVar = getShortcutClientVarsWikiInfo()) !== null && _getShortcutClientVar !== void 0 && _getShortcutClientVar.isWiki);
  }

  return !!((_getShortcutBasicClie = getShortcutBasicClientVarsWikiInfo()) !== null && _getShortcutBasicClie !== void 0 && _getShortcutBasicClie.isWiki);
};

export { BIGINT_SUPPORT, ID_PREFIX_REGEX, Logger, ToolbarModeDocType, addEnterpriseXsrfInterceptor, addLocalLogCgiInterceptor, addOrUpdateQuery, cacheClientData, checkIsCurrentUser, contactDocOwner, cube, dontWaitFor, enterpriseXsrfInterceptor, formatBytes, getAppCreatorName, getAppCreatorVid, getBasicClientVarsWikiInfo, getCgiFunc, getCgiPath, getClientVarsWikiInfo, getCookie, getCubeDocId, getCubeFileType, getCubePlatform, getCubeUserId, getCubeWeixinWorkVersion, getOriginDocBasicClientVarsWikiInfo, getOriginDocClientVarsWikiInfo, getQuery, getQueryV2, getShortcutBasicClientVarsWikiInfo, getShortcutClientVarsWikiInfo, getToolbarModeFromCookie, getUserId, getWindowWidth, isAppId, isOpenId, isOriginDocWikiDoc, isPad, isPadAndAbrove418, isShortCutWikiDoc, isSpecialCreatorId, isVid, isWedriveUid, isWedriveUin, isWikiDoc, isWikiEmbeded, isWikiShortcut, isWikiShortcutId, isWxTinyid, isXid, lazyGetWikiShortcutId, localLog, log, openApplyUseUrl, openUrlInWecom, openVipUrl, parseXhrError, sendCubeRequest, setCookie, setToolbarModeToCookie, setWindowWidth, shareLanguage, shouldDisableTryJumpToWiki, sleep, subscribeIsPad, subscribeIsPadAndAbrove418, substrObject };
